import { useContext, type ContextType } from 'react';

import { useSharedPluginStateWithSelector } from '@atlaskit/editor-common/useSharedPluginStateWithSelector';
import type { PublicPluginAPI } from '@atlaskit/editor-common/types/next-editor-plugin';
import type { EditorViewModePlugin } from '@atlaskit/editor-plugin-editor-viewmode/editorViewmodePluginType';

import { EditorContextPanelContext } from '@confluence/editor-context-panel/entry-points/EditorContextPanelContext.ts';

/**
 * Returns `true` when the editor is in view mode (e.g. live-page view).
 * In view mode the editor is non-editable and snippet insertion would silently fail,
 * so callers should disable insert interactions.
 */
export const useIsEditorViewMode = (): boolean => {
	const { editorAPI } = useContext(EditorContextPanelContext) as ContextType<
		typeof EditorContextPanelContext
	>;

	return useSharedPluginStateWithSelector(
		editorAPI as PublicPluginAPI<EditorViewModePlugin>,
		['editorViewMode'],
		(states) => states.editorViewModeState?.mode === 'view',
	);
};
